import React from "react";
import * as Icons from "lucide-react";
import { WHY_US, IMAGES } from "../mock";
import Reveal from "./Reveal";

const WhyUsSection = () => (
  <section className="py-16 sm:py-20 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6">
      <Reveal className="text-center mb-12 max-w-2xl mx-auto">
        <span className="text-orange-brand font-bold text-sm uppercase tracking-wide">Our Specifications</span>
        <h2 className="text-3xl sm:text-4xl font-bold text-navy font-head mt-2">Why We Are The Best?</h2>
        <p className="text-navy/60 mt-3">Unique, one-of-its-kind laundry &amp; dry-cleaning services for garments, shoes and bags.</p>
      </Reveal>

      <div className="grid lg:grid-cols-3 gap-6 items-center">
        <div className="space-y-6">
          {WHY_US.slice(0, 3).map((w, i) => <WhyCard key={w.title} w={w} delay={i * 60} />)}
        </div>
        <Reveal delay={120} className="hidden lg:block">
          <img src={`${IMAGES.machineCloseup}?w=600&q=80`} alt="Laundryma processing" className="rounded-3xl shadow-xl w-full h-[440px] object-cover" />
        </Reveal>
        <div className="space-y-6">
          {WHY_US.slice(3, 6).map((w, i) => <WhyCard key={w.title} w={w} delay={i * 60} />)}
        </div>
      </div>
    </div>
  </section>
);

const WhyCard = ({ w, delay }) => {
  const Icon = Icons[w.icon] || Icons.Sparkles;
  return (
    <Reveal delay={delay}>
      <div className="flex gap-4 bg-[#f7f9fc] hover:bg-white rounded-2xl p-5 border border-transparent hover:border-orange-brand/20 hover:shadow-md transition-all">
        <span className="w-12 h-12 shrink-0 rounded-xl bg-orange-brand/10 text-orange-brand flex items-center justify-center">
          <Icon size={22} />
        </span>
        <div>
          <h3 className="font-semibold text-navy font-head">{w.title}</h3>
          <p className="text-sm text-navy/60 mt-1 leading-relaxed">{w.desc}</p>
        </div>
      </div>
    </Reveal>
  );
};

export default WhyUsSection;
